import { PlaceholderPage } from "@/components/placeholder/PlaceholderPage";
import { ClipboardList } from "lucide-react";
import { MainLayout } from "@/components/MainLayout";

export default function HealthClinicsProceduresPage() {
  return (
<MainLayout>
    <PlaceholderPage
      title="Procedimentos"
      description="Gerencie os procedimentos realizados na sua clínica."
      icon={ClipboardList}
    />
  
    </MainLayout>);
}

